import React from 'react'
import PropTypes from 'prop-types'
import { ErrorMessage } from 'formik'

const Error = ({ error, name = '' }) => (
    <>
        {typeof error === 'string' ? (
            <div
                className="error-text !text-danger !italic !mt-2"
                role="alert"
                data-testid={`error-${name.toLowerCase().replaceAll(' ', '-')}`}
            >
                {error}
            </div>
        ) : (
            <ErrorMessage name={name}>
                {msg => (
                    <div
                        className="error-text !text-danger !italic !mt-2"
                        role="alert"
                        data-testid={`error-${name.toLowerCase().replaceAll(' ', '-')}`}
                    >
                        {msg}
                    </div>
                )}
            </ErrorMessage>
        )}
    </>
)

Error.displayName = 'Error'

Error.propTypes = {
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
}

export default Error
